/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleRpcStatus } from './GoogleRpcStatus';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusFromJSONTyped,
  GoogleRpcStatusToJSON,
  GoogleRpcStatusToJSONTyped,
} from './GoogleRpcStatus';
import type { V2beta1RuntimeState } from './V2beta1RuntimeState';
import {
  V2beta1RuntimeStateFromJSON,
  V2beta1RuntimeStateFromJSONTyped,
  V2beta1RuntimeStateToJSON,
  V2beta1RuntimeStateToJSONTyped,
} from './V2beta1RuntimeState';

/**
 * Timestamped representation of a runtime state with an optional error.
 * @export
 * @interface V2beta1RuntimeStatus
 */
export interface V2beta1RuntimeStatus {
  /**
   * Update time of this state.
   * @type {Date}
   * @memberof V2beta1RuntimeStatus
   */
  update_time?: Date;
  /**
   *
   * @type {V2beta1RuntimeState}
   * @memberof V2beta1RuntimeStatus
   */
  state?: V2beta1RuntimeState;
  /**
   *
   * @type {GoogleRpcStatus}
   * @memberof V2beta1RuntimeStatus
   */
  error?: GoogleRpcStatus;
}

/**
 * Check if a given object implements the V2beta1RuntimeStatus interface.
 */
export function instanceOfV2beta1RuntimeStatus(value: object): value is V2beta1RuntimeStatus {
  return true;
}

export function V2beta1RuntimeStatusFromJSON(json: any): V2beta1RuntimeStatus {
  return V2beta1RuntimeStatusFromJSONTyped(json, false);
}

export function V2beta1RuntimeStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1RuntimeStatus {
  if (json == null) {
    return json;
  }
  return {
    update_time: json['update_time'] == null ? undefined : new Date(json['update_time']),
    state: json['state'] == null ? undefined : V2beta1RuntimeStateFromJSON(json['state']),
    error: json['error'] == null ? undefined : GoogleRpcStatusFromJSON(json['error']),
  };
}

export function V2beta1RuntimeStatusToJSON(json: any): V2beta1RuntimeStatus {
  return V2beta1RuntimeStatusToJSONTyped(json, false);
}

export function V2beta1RuntimeStatusToJSONTyped(
  value?: V2beta1RuntimeStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    update_time:
      value['update_time'] == null ? value['update_time'] : value['update_time'].toISOString(),
    state: V2beta1RuntimeStateToJSON(value['state']),
    error: GoogleRpcStatusToJSON(value['error']),
  };
}
